import React, { useState } from "react";
import DynamicForm from "../components/sections/DynamicForm.jsx";
import { careerFormFields } from "../data/careerFormFields.js";
import PageCTA from '../components/sections/pageCTA.jsx';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const ACCESS_KEY = process.env.REACT_APP_CAREER_ACCESS_KEY;

// ─── ICON ──────────────────────────────────────────────────────────────────────
const Icon = ({ d, size = 20, className = "", style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={1.8} strokeLinecap="round"
    strokeLinejoin="round" className={className} style={style}>
    <path d={d} />
  </svg>
);

const ICONS = {
  // Existing
  hub:       "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
  lab:       "M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v11m0 0H5a2 2 0 00-2 2v4a2 2 0 002 2h10a2 2 0 002-2v-4a2 2 0 00-2-2h-4m0 0V3",
  insights:  "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  graph:     "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z",
  whatsapp:  "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
  chaos:     "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0 0v-8m0 0L8 9m4 5l4-5",
  heka:      "M13 10V3L4 14h7v7l9-11h-7z",
  order:     "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
  arrow:     "M5 12h14M12 5l7 7-7 7",
  target:    "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-6a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
  spark:     "M13 2L3 14h9l-1 8 10-12h-9l1-8z",

  // New — perks
  equity:    "M12 2v20M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6",
  remote:    "M3 12a9 9 0 1018 0 9 9 0 00-18 0M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10zM2 12h20",
  learning:  "M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 004 22h16a2 2 0 002-2V4a2 2 0 00-2-2H6.5A2.5 2.5 0 004 4.5v15z",
  health:    "M22 12h-4l-3 9L9 3l-3 9H2",
  clock:     "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-6V12l4-2",
  growth:    "M23 6l-9.5 9.5-5-5L1 18M17 6h6v6",

  // New — values
  brain:     "M9.5 2A2.5 2.5 0 0112 4.5v15a2.5 2.5 0 01-4.96-.44 2.5 2.5 0 01-2.96-3.08 3 3 0 01-.34-5.58 2.5 2.5 0 013.32-3.97A2.5 2.5 0 019.5 2zM14.5 2A2.5 2.5 0 0112 4.5v15a2.5 2.5 0 004.96-.44 2.5 2.5 0 002.96-3.08 3 3 0 00.34-5.58 2.5 2.5 0 00-3.32-3.97A2.5 2.5 0 0014.5 2z",
  ship:      "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.64A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.11 7.77a16 16 0 006.11 6.11l1.07-1.07a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z",
  impact:    "M18 20V10M12 20V4M6 20v-6",
  collab:    "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",

  // Who we hire
  code:      "M16 18l6-6-6-6M8 6l-6 6 6 6",
  layers:    "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
  pen:       "M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z",
  data:      "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12",
};

// ─────────────────────────────────────────────
// STYLES
// ─────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,300&display=swap');

  .career-title-gradient {
    background: linear-gradient(110deg, #fbbf24 35%, #a78bfa 50%, #fbbf24 65%);
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: career-shimmer 8s linear infinite;
  }

  @keyframes career-shimmer {
    0%   { background-position: 0% 50%; }
    100% { background-position: 200% 50%; }
  }

  .career-dot-grid {
    background-image: radial-gradient(circle, rgba(251,191,36,0.12) 1px, transparent 1px);
    background-size: 28px 28px;
  }

  .career-mesh-bg {
    background-image: 
      radial-gradient(at 20% 30%, rgba(251,191,36,0.08) 0px, transparent 50%),
      radial-gradient(at 80% 70%, rgba(168,85,247,0.08) 0px, transparent 50%),
      radial-gradient(at 50% 50%, rgba(6,182,212,0.05) 0px, transparent 50%);
  }

  .career-grid-lines {
    background-image: 
      linear-gradient(rgba(251,191,36,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(251,191,36,0.03) 1px, transparent 1px);
    background-size: 40px 40px;
  }

  @keyframes career-fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .career-fade   { animation: career-fadeUp 0.7s ease forwards; }
  .career-fade-1 { animation-delay: 0.05s; opacity: 0; }
  .career-fade-2 { animation-delay: 0.15s; opacity: 0; }
  .career-fade-3 { animation-delay: 0.25s; opacity: 0; }
  .career-fade-4 { animation-delay: 0.35s; opacity: 0; }

  .career-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(251,191,36,0.3), transparent);
  }

  /* Bento cards */
  .career-bento {
    transition: all 0.3s cubic-bezier(0.22,1,0.36,1);
  }
  .career-bento:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.3);
  }

  /* Perk bento hover glow */
  .perk-card-violet:hover  { border-color: rgba(167,139,250,0.4) !important; box-shadow: 0 0 24px rgba(167,139,250,0.08); }
  .perk-card-amber:hover   { border-color: rgba(251,191,36,0.4)  !important; box-shadow: 0 0 24px rgba(251,191,36,0.08);  }
  .perk-card-cyan:hover    { border-color: rgba(6,182,212,0.4)   !important; box-shadow: 0 0 24px rgba(6,182,212,0.08);   }
  .perk-card-emerald:hover { border-color: rgba(52,211,153,0.4)  !important; box-shadow: 0 0 24px rgba(52,211,153,0.08);  }
  .perk-card-pink:hover    { border-color: rgba(236,72,153,0.4)  !important; box-shadow: 0 0 24px rgba(236,72,153,0.08);  }
  .perk-card-red:hover     { border-color: rgba(248,113,113,0.4) !important; box-shadow: 0 0 24px rgba(248,113,113,0.08); }
  .perk-card-sky:hover     { border-color: rgba(56,189,248,0.4)  !important; box-shadow: 0 0 24px rgba(56,189,248,0.08);  }
  .perk-card-indigo:hover  { border-color: rgba(129,140,248,0.4) !important; box-shadow: 0 0 24px rgba(129,140,248,0.08); }

  /* Perk icon float */
  @keyframes perk-float {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-4px); }
  }
  .perk-icon-float { animation: perk-float 3s ease-in-out infinite; }

  /* Stack layer pulse */
  @keyframes stack-pulse {
    0%, 100% { opacity: 0.5; transform: scaleX(1); }
    50%       { opacity: 1;   transform: scaleX(1.02); }
  }

  /* Radar for who we hire */
  @keyframes who-radar {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  /* Node pulse */
  @keyframes node-pulse {
    0%, 100% { opacity: 0.6; transform: scale(1); }
    50%       { opacity: 1;   transform: scale(1.15); }
  }
  .career-node { animation: node-pulse 2s ease-in-out infinite; }

  /* Flow line */
  @keyframes career-flow {
    0%   { stroke-dashoffset: 20; }
    100% { stroke-dashoffset: 0; }
  }
  .career-flow-line { animation: career-flow 1.8s linear infinite; }

  /* Form styles */
  .career-form-container { position: relative; overflow: hidden; }
  .career-form-container::before {
    content: '';
    position: absolute; top: -50%; left: -50%;
    width: 200%; height: 200%;
    background: radial-gradient(circle, rgba(168,85,247,0.03) 0%, transparent 70%);
    animation: career-form-glow 8s ease-in-out infinite;
  }
  @keyframes career-form-glow {
    0%, 100% { transform: translate(0, 0); }
    50%       { transform: translate(10%, 10%); }
  }

  .career-btn-primary {
    position: relative; overflow: hidden;
    transition: all 0.3s ease;
  }
  .career-btn-primary::after {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
    transform: translateX(-100%);
    transition: transform 0.5s ease;
  }
  .career-btn-primary:hover::after { transform: translateX(100%); }
  .career-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(217,119,6,0.35);
    background-color: #d97706;
  }

  .career-btn-secondary { transition: all 0.3s ease; }
  .career-btn-secondary:hover {
    transform: translateY(-2px);
    background: rgba(109,40,217,0.1);
    border-color: rgba(109,40,217,0.6);
    color: #c4b5fd;
  }

  /* Thinking Stack infographic */
  @keyframes stack-layer-in {
    from { opacity: 0; transform: translateX(-16px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  .stack-layer { animation: stack-layer-in 0.6s ease backwards; }

  @keyframes stack-glow-pulse {
    0%, 100% { box-shadow: 0 0 0px rgba(251,191,36,0); }
    50%       { box-shadow: 0 0 20px rgba(251,191,36,0.12); }
  }
  .stack-active { animation: stack-glow-pulse 2.5s ease-in-out infinite; }
`;

// ─── TOAST ─────────────────────────────────────────────────────────────────────
const Toast = ({ toast }) => {
  if (!toast) return null;
  return (
    <div className={`fixed top-6 right-6 z-50 px-6 py-4 rounded-lg shadow-2xl text-sm font-medium
      transition-all duration-300 max-w-sm backdrop-blur-xl
      ${toast.type === "success"
        ? "bg-emerald-900/95 border border-emerald-500/40 text-emerald-200"
        : "bg-red-900/95 border border-red-500/40 text-red-200"}`}>
      {toast.message}
    </div>
  );
};

// ─── RESUME UPLOAD ──────────────────────────────────────────────────────────────
const uploadResume = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${API_URL}/api/v1/career/upload-resume`, { method: "POST", body: formData });
  const result = await response.json();
  if (!response.ok) throw new Error(result?.error?.message || "Resume upload failed");
  return result.data.resume_url;
};

// ─── BUILD PAYLOAD ──────────────────────────────────────────────────────────────
const buildPayload = (data, resumeUrl) => {
  const countryCode = (data.countryCode || "").trim();
  const phoneNumber = (data.phone || "").trim();
  const fullPhone = countryCode ? `${countryCode}${phoneNumber}` : phoneNumber;
  return {
    first_name: (data.firstName || "").trim(),
    last_name:  (data.lastName  || "").trim(),
    email:      (data.email     || "").trim(),
    phone:      fullPhone,
    referral_code: (data.referral || "").trim(),
    resume_url: resumeUrl || null,
  };
};

// ─────────────────────────────────────────────────────────────────────────────
// THINKING STACK — infographic
// ─────────────────────────────────────────────────────────────────────────────
const ThinkingStack = () => {
  const layers = [
    {
      level: "04",
      label: "Intelligence Layer",
      desc: "Reasoning, pattern recognition, outcome-based decisions",
      color: "rgba(251,191,36,1)",
      bg: "rgba(251,191,36,0.08)",
      border: "rgba(251,191,36,0.3)",
      width: "100%",
      delay: "0.1s",
    },
    {
      level: "03",
      label: "Application Layer",
      desc: "Products, workflows, and domain-specific intelligence tools",
      color: "rgba(167,139,250,1)",
      bg: "rgba(167,139,250,0.07)",
      border: "rgba(167,139,250,0.25)",
      width: "90%",
      delay: "0.2s",
    },
    {
      level: "02",
      label: "Engineering Layer",
      desc: "APIs, pipelines, agent frameworks, and model orchestration",
      color: "rgba(6,182,212,1)",
      bg: "rgba(6,182,212,0.06)",
      border: "rgba(6,182,212,0.22)",
      width: "80%",
      delay: "0.3s",
    },
    {
      level: "01",
      label: "Foundation Layer",
      desc: "First principles, systems thinking, and core infrastructure",
      color: "rgba(52,211,153,1)",
      bg: "rgba(52,211,153,0.06)",
      border: "rgba(52,211,153,0.2)",
      width: "70%",
      delay: "0.4s",
    },
  ];

  return (
    <section className="mb-20 career-fade career-fade-2">
      <div className="text-center mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
          What You'll Build On
        </p>
        <h2 className="text-2xl font-semibold text-slate-100 tracking-tight mb-3">
          The Thinking Stack
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm leading-relaxed">
          Every engineer at HEKAOS works across the full stack of intelligence — from foundation to reasoning layer.
        </p>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-3">
        {layers.map((layer, i) => (
          <div key={i}
            className="stack-layer stack-active"
            style={{
              animationDelay: layer.delay,
              marginLeft: `calc(100% - ${layer.width})`,
              width: layer.width,
            }}>
            <div className="rounded-xl border px-6 py-4 flex items-center gap-5 transition-all duration-300 hover:scale-[1.01]"
              style={{ background: layer.bg, borderColor: layer.border }}>
              {/* Level badge */}
              <div className="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center"
                style={{ background: `${layer.bg}`, border: `1px solid ${layer.border}` }}>
                <span className="text-xs font-bold font-mono" style={{ color: layer.color }}>
                  {layer.level}
                </span>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <p className="font-bold text-sm tracking-tight mb-0.5" style={{ color: layer.color }}>
                  {layer.label}
                </p>
                <p className="text-slate-500 text-xs leading-relaxed">{layer.desc}</p>
              </div>

              {/* Glow dot */}
              <div className="flex-shrink-0 w-2 h-2 rounded-full career-node"
                style={{ background: layer.color, boxShadow: `0 0 8px ${layer.color}` }} />
            </div>
          </div>
        ))}

        {/* Bottom connector */}
        <div className="flex justify-end pr-4 mt-1">
          <div className="flex flex-col items-center gap-1">
            <div className="w-px h-8 bg-gradient-to-b from-emerald-500/30 to-transparent" />
            <span className="text-xs text-slate-600 font-mono tracking-widest">FOUNDATION</span>
          </div>
        </div>
      </div>
    </section>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPANY VALUES
// ─────────────────────────────────────────────────────────────────────────────

// Value card accents
const BrainAccent = () => (
  <svg width="48" height="36" viewBox="0 0 48 36" fill="none">
    <circle cx="24" cy="18" r="14" stroke="rgba(167,139,250,0.2)" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="24" cy="18" r="8"  stroke="rgba(167,139,250,0.4)" strokeWidth="1.5" />
    <circle cx="24" cy="18" r="3"  fill="rgba(167,139,250,0.9)"   className="career-node" />
    <line x1="10" y1="18" x2="16" y2="18" stroke="rgba(167,139,250,0.4)" strokeWidth="1.5" />
    <line x1="32" y1="18" x2="38" y2="18" stroke="rgba(167,139,250,0.4)" strokeWidth="1.5" />
  </svg>
);

const ShipAccent = () => (
  <svg width="48" height="36" viewBox="0 0 48 36" fill="none">
    {[0,1,2].map(i => (
      <line key={i} x1={6 + i*14} y1="18" x2={16 + i*14} y2="18"
        stroke={`rgba(6,182,212,${0.3 + i*0.2})`} strokeWidth="1.5" strokeLinecap="round"
        style={{ animation: `career-flow 1.4s ease-in-out ${i*0.2}s infinite` }}
        strokeDasharray="4 2"
      />
    ))}
    <circle cx="40" cy="18" r="4" fill="rgba(6,182,212,0.8)" className="career-node" />
  </svg>
);

const ImpactAccent = () => (
  <svg width="48" height="36" viewBox="0 0 48 36" fill="none">
    {[8, 16, 24, 32, 40].map((x, i) => (
      <rect key={i} x={x-3} y={28 - [10,18,14,24,20][i]} width="6" height={[10,18,14,24,20][i]}
        rx="2" fill={`rgba(251,191,36,${0.25 + i*0.12})`}
        style={{ transformOrigin: `${x}px 28px`, animation: `stack-pulse 2s ease-in-out ${i*0.15}s infinite` }}
      />
    ))}
  </svg>
);

const CollabAccent = () => (
  <svg width="48" height="36" viewBox="0 0 48 36" fill="none">
    <circle cx="12" cy="18" r="5" fill="rgba(52,211,153,0.3)" stroke="rgba(52,211,153,0.5)" strokeWidth="1.5" className="career-node" style={{ animationDelay: "0s" }} />
    <circle cx="24" cy="10" r="5" fill="rgba(52,211,153,0.3)" stroke="rgba(52,211,153,0.5)" strokeWidth="1.5" className="career-node" style={{ animationDelay: "0.3s" }} />
    <circle cx="36" cy="18" r="5" fill="rgba(52,211,153,0.3)" stroke="rgba(52,211,153,0.5)" strokeWidth="1.5" className="career-node" style={{ animationDelay: "0.6s" }} />
    <line x1="17" y1="15" x2="19" y2="13" stroke="rgba(52,211,153,0.35)" strokeWidth="1.5" />
    <line x1="29" y1="13" x2="31" y2="15" stroke="rgba(52,211,153,0.35)" strokeWidth="1.5" />
  </svg>
);

const CompanyValues = () => {
  const values = [
    {
      icon: ICONS.brain,
      accent: <BrainAccent />,
      title: "Intelligence First",
      desc: "We build systems that reason from first principles — not systems that merely execute.",
      color: "violet",
      iconColor: "text-violet-400",
      borderColor: "border-violet-800/30",
      bgColor: "rgba(139,92,246,0.05)",
      glowColor: "rgba(139,92,246,0.06)",
      delay: "0.1s",
    },
    {
      icon: ICONS.ship,
      accent: <ShipAccent />,
      title: "Ship & Learn",
      desc: "Move with precision, not just speed. Ship, observe, refine. Repeat until the result holds.",
      color: "cyan",
      iconColor: "text-cyan-400",
      borderColor: "border-cyan-800/30",
      bgColor: "rgba(6,182,212,0.05)",
      glowColor: "rgba(6,182,212,0.06)",
      delay: "0.2s",
    },
    {
      icon: ICONS.impact,
      accent: <ImpactAccent />,
      title: "Outcome Driven",
      desc: "Every decision is a hypothesis tested against real-world impact. No outputs without outcomes.",
      color: "amber",
      iconColor: "text-amber-400",
      borderColor: "border-amber-800/30",
      bgColor: "rgba(251,191,36,0.05)",
      glowColor: "rgba(251,191,36,0.06)",
      delay: "0.3s",
    },
    {
      icon: ICONS.collab,
      accent: <CollabAccent />,
      title: "Radical Collaboration",
      desc: "The best idea wins — regardless of where it comes from or who proposed it.",
      color: "emerald",
      iconColor: "text-emerald-400",
      borderColor: "border-emerald-800/30",
      bgColor: "rgba(52,211,153,0.05)",
      glowColor: "rgba(52,211,153,0.06)",
      delay: "0.4s",
    },
  ];

  return (
    <section className="mb-20 career-fade career-fade-2">
      <div className="text-center mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
          How We Operate
        </p>
        <h2 className="text-2xl font-semibold text-slate-100 tracking-tight mb-3">
          Core Values
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm leading-relaxed">
          Not mantras on a wall — principles that shape every product decision and engineering choice.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {values.map((v, i) => (
          <div key={i}
            className={`career-bento rounded-2xl border ${v.borderColor} p-6 flex flex-col gap-4 overflow-hidden relative`}
            style={{ background: v.bgColor, animationDelay: v.delay }}>
            <div className="absolute inset-0 pointer-events-none"
              style={{ background: `radial-gradient(ellipse at 50% 100%, ${v.glowColor} 0%, transparent 70%)` }} />

            {/* Icon row */}
            <div className="flex items-center justify-between">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center"
                style={{ background: `${v.bgColor}`, border: `1px solid ${v.borderColor.replace("border-","").replace("/30","").replace("-800","800")}30` }}>
                <Icon d={v.icon} size={18} className={v.iconColor} />
              </div>
              <div className="perk-icon-float" style={{ animationDelay: v.delay }}>
                {v.accent}
              </div>
            </div>

            <div>
              <h3 className={`font-bold text-sm tracking-tight mb-1.5 ${v.iconColor}`}>{v.title}</h3>
              <p className="text-slate-400 text-xs leading-relaxed">{v.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// PERKS — bento grid
// ─────────────────────────────────────────────────────────────────────────────

// Per-perk mini accents
const EquityAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <polyline points="4,28 16,16 26,22 40,8 48,12"
      stroke="rgba(251,191,36,0.6)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="40" cy="8" r="3" fill="rgba(251,191,36,0.9)" className="career-node" />
  </svg>
);

const RemoteAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <circle cx="26" cy="18" r="12" stroke="rgba(6,182,212,0.25)" strokeWidth="1" strokeDasharray="3 3" />
    <ellipse cx="26" cy="18" rx="5" ry="12" stroke="rgba(6,182,212,0.4)" strokeWidth="1" strokeDasharray="3 3" />
    <line x1="14" y1="18" x2="38" y2="18" stroke="rgba(6,182,212,0.35)" strokeWidth="1" />
    <circle cx="26" cy="18" r="2.5" fill="rgba(6,182,212,0.9)" className="career-node" />
  </svg>
);

const LearningAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    {[0,1,2].map(i => (
      <line key={i} x1="8" y1={10 + i*9} x2={32 + i*4} y2={10 + i*9}
        stroke={`rgba(167,139,250,${0.3 + i*0.2})`} strokeWidth="1.5" strokeLinecap="round" />
    ))}
    <circle cx="44" cy="19" r="5" fill="none" stroke="rgba(167,139,250,0.5)" strokeWidth="1.5" className="career-node" style={{ animationDelay: "0.3s" }} />
    <line x1="44" y1="16" x2="44" y2="19" stroke="rgba(167,139,250,0.8)" strokeWidth="1.5" />
    <line x1="44" y1="19" x2="47" y2="19" stroke="rgba(167,139,250,0.8)" strokeWidth="1.5" />
  </svg>
);

const HealthAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <polyline points="4,18 12,18 16,8 20,28 24,14 28,22 32,18 48,18"
      stroke="rgba(52,211,153,0.7)" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"
      style={{ animation: "career-flow 2s linear infinite" }} strokeDasharray="60 10" />
  </svg>
);

const ClockAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <circle cx="26" cy="18" r="13" stroke="rgba(248,113,113,0.3)" strokeWidth="1.5" />
    <line x1="26" y1="18" x2="26" y2="9"  stroke="rgba(248,113,113,0.7)" strokeWidth="2" strokeLinecap="round" />
    <line x1="26" y1="18" x2="33" y2="18" stroke="rgba(248,113,113,0.7)" strokeWidth="2" strokeLinecap="round" />
    <circle cx="26" cy="18" r="2" fill="rgba(248,113,113,0.9)" />
    {[0,60,120,180,240,300].map((deg,i) => {
      const r = (deg * Math.PI) / 180;
      return <circle key={i} cx={26 + 11*Math.sin(r)} cy={18 - 11*Math.cos(r)} r="1" fill="rgba(248,113,113,0.3)" />;
    })}
  </svg>
);

const ProblemsAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <circle cx="26" cy="18" r="13" stroke="rgba(251,191,36,0.2)" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="26" cy="18" r="8"  stroke="rgba(251,191,36,0.35)" strokeWidth="1.5" strokeDasharray="3 3" />
    <circle cx="26" cy="18" r="3"  fill="rgba(251,191,36,0.9)" className="career-node" />
  </svg>
);

const GrowthAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <polyline points="4,30 14,20 24,24 34,10 48,6"
      stroke="rgba(56,189,248,0.6)" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <polyline points="40,6 48,6 48,14"
      stroke="rgba(56,189,248,0.6)" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="34" cy="10" r="3" fill="rgba(56,189,248,0.8)" className="career-node" style={{ animationDelay: "0.4s" }} />
  </svg>
);

const AIToolsAccent = () => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none">
    <rect x="14" y="8" width="24" height="20" rx="4" stroke="rgba(129,140,248,0.4)" strokeWidth="1.5" fill="rgba(129,140,248,0.05)" />
    <line x1="14" y1="15" x2="38" y2="15" stroke="rgba(129,140,248,0.25)" strokeWidth="1" />
    <circle cx="19" cy="11.5" r="1.5" fill="rgba(129,140,248,0.5)" />
    <circle cx="24" cy="11.5" r="1.5" fill="rgba(129,140,248,0.3)" />
    <rect x="18" y="19" width="16" height="2" rx="1" fill="rgba(129,140,248,0.3)" />
    <rect x="18" y="23" width="10" height="2" rx="1" fill="rgba(129,140,248,0.2)" />
  </svg>
);

const Perks = () => {
  const perks = [
    {
      icon: ICONS.equity,   accent: <EquityAccent />,   text: "Competitive salary with equity",
      sub:  "You build it, you own part of it.",
      colorClass: "perk-card-amber",   borderColor: "rgba(251,191,36,0.18)",   iconColor: "text-amber-400",   iconBg: "rgba(251,191,36,0.08)",   delay: "0.1s",
    },
    {
      icon: ICONS.remote,   accent: <RemoteAccent />,   text: "Fully remote, async-first",
      sub:  "We trust you to own your time.",
      colorClass: "perk-card-cyan",    borderColor: "rgba(6,182,212,0.18)",    iconColor: "text-cyan-400",    iconBg: "rgba(6,182,212,0.08)",    delay: "0.15s",
    },
    {
      icon: ICONS.learning, accent: <LearningAccent />, text: "Dedicated learning budget",
      sub:  "Books, courses, conferences, research.",
      colorClass: "perk-card-violet",  borderColor: "rgba(167,139,250,0.18)",  iconColor: "text-violet-400",  iconBg: "rgba(167,139,250,0.08)",  delay: "0.2s",
    },
    {
      icon: ICONS.health,   accent: <HealthAccent />,   text: "Health & wellness coverage",
      sub:  "Full coverage for you and yours.",
      colorClass: "perk-card-emerald", borderColor: "rgba(52,211,153,0.18)",   iconColor: "text-emerald-400", iconBg: "rgba(52,211,153,0.08)",   delay: "0.25s",
    },
    {
      icon: ICONS.clock,    accent: <ClockAccent />,    text: "No performative hours",
      sub:  "We measure output, not attendance.",
      colorClass: "perk-card-red",     borderColor: "rgba(248,113,113,0.18)",  iconColor: "text-red-400",     iconBg: "rgba(248,113,113,0.08)",  delay: "0.3s",
    },
    {
      icon: ICONS.target,   accent: <ProblemsAccent />, text: "Hard problems only",
      sub:  "No maintenance work, no legacy debt.",
      colorClass: "perk-card-amber",   borderColor: "rgba(251,191,36,0.18)",   iconColor: "text-amber-400",   iconBg: "rgba(251,191,36,0.08)",   delay: "0.35s",
    },
    {
      icon: ICONS.growth,   accent: <GrowthAccent />,   text: "Grow fast, own your domain",
      sub:  "Shape the product direction.",
      colorClass: "perk-card-sky",     borderColor: "rgba(56,189,248,0.18)",   iconColor: "text-sky-400",     iconBg: "rgba(56,189,248,0.08)",   delay: "0.4s",
    },
    {
      icon: ICONS.spark,    accent: <AIToolsAccent />,  text: "Full AI tool access",
      sub:  "Latest models and infrastructure, day one.",
      colorClass: "perk-card-indigo",  borderColor: "rgba(129,140,248,0.18)",  iconColor: "text-indigo-400",  iconBg: "rgba(129,140,248,0.08)",  delay: "0.45s",
    },
  ];

  return (
    <section className="mb-20 career-fade career-fade-3">
      <div className="text-center mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
          Why HEKAOS
        </p>
        <h2 className="text-2xl font-semibold text-slate-100 tracking-tight mb-3">
          We Don't Hire for Roles. We Hire for Thinking.
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm leading-relaxed">
          What you get when you join a team that takes intelligence engineering seriously.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {perks.map((perk, i) => (
          <div key={i}
            className={`career-bento ${perk.colorClass} rounded-2xl border bg-slate-900 p-5 flex flex-col gap-4 overflow-hidden relative`}
            style={{ borderColor: perk.borderColor, animationDelay: perk.delay }}>
            {/* Icon + accent row */}
            <div className="flex items-center justify-between">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: perk.iconBg, border: `1px solid ${perk.borderColor}` }}>
                <Icon d={perk.icon} size={18} className={perk.iconColor} />
              </div>
              <div className="perk-icon-float" style={{ animationDelay: perk.delay }}>
                {perk.accent}
              </div>
            </div>

            {/* Text */}
            <div>
              <p className={`font-bold text-sm tracking-tight mb-1 ${perk.iconColor}`}>{perk.text}</p>
              <p className="text-slate-500 text-xs leading-relaxed">{perk.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// WHO WE HIRE
// ─────────────────────────────────────────────────────────────────────────────
const AIEngAccent = () => (
  <svg width="60" height="40" viewBox="0 0 60 40" fill="none">
    <circle cx="30" cy="20" r="16" stroke="rgba(167,139,250,0.15)" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="30" cy="20" r="10" stroke="rgba(167,139,250,0.3)"  strokeWidth="1.5" strokeDasharray="3 3" />
    <g style={{ transformOrigin: "30px 20px", animation: "who-radar 3s linear infinite" }}>
      <line x1="30" y1="20" x2="30" y2="4" stroke="rgba(167,139,250,0.7)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M30,20 L44,8 A16,16 0 0,0 30,4 Z" fill="rgba(167,139,250,0.07)" />
    </g>
    <circle cx="30" cy="20" r="2.5" fill="rgba(167,139,250,0.9)" />
    <circle cx="42" cy="12" r="2"   fill="rgba(167,139,250,0.6)" className="career-node" style={{ animationDelay: "0.5s" }} />
  </svg>
);

const DevAccent = () => (
  <svg width="60" height="40" viewBox="0 0 60 40" fill="none">
    <rect x="8" y="10" width="44" height="26" rx="4" stroke="rgba(6,182,212,0.3)" strokeWidth="1.5" fill="rgba(6,182,212,0.04)" />
    <line x1="8" y1="18" x2="52" y2="18" stroke="rgba(6,182,212,0.2)" strokeWidth="1" />
    <circle cx="14" cy="14" r="2" fill="rgba(248,113,113,0.5)" />
    <circle cx="21" cy="14" r="2" fill="rgba(251,191,36,0.5)" />
    <circle cx="28" cy="14" r="2" fill="rgba(52,211,153,0.5)" />
    <polyline points="14,25 20,22 26,28" stroke="rgba(6,182,212,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="30" y1="22" x2="46" y2="22" stroke="rgba(6,182,212,0.3)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="30" y1="27" x2="40" y2="27" stroke="rgba(6,182,212,0.2)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const DesignAccent = () => (
  <svg width="60" height="40" viewBox="0 0 60 40" fill="none">
    <circle cx="22" cy="20" r="10" stroke="rgba(251,191,36,0.3)" strokeWidth="1.5" fill="rgba(251,191,36,0.04)" />
    <circle cx="38" cy="20" r="10" stroke="rgba(251,191,36,0.3)" strokeWidth="1.5" fill="rgba(251,191,36,0.04)" />
    <path d="M28,12 Q30,20 28,28" fill="rgba(251,191,36,0.12)" stroke="rgba(251,191,36,0.5)" strokeWidth="1" />
    <circle cx="30" cy="20" r="2.5" fill="rgba(251,191,36,0.9)" className="career-node" />
  </svg>
);

const DataAccent = () => (
  <svg width="60" height="40" viewBox="0 0 60 40" fill="none">
    {[0,1,2,3,4].map((i) => {
      const h = [20, 30, 18, 28, 24][i];
      return (
        <rect key={i} x={8 + i*10} y={36-h} width="7" height={h} rx="2"
          fill={`rgba(52,211,153,${0.2 + i*0.1})`}
          stroke={`rgba(52,211,153,${0.3 + i*0.1})`} strokeWidth="1"
          style={{ animation: `stack-pulse 2s ease-in-out ${i*0.15}s infinite` }}
        />
      );
    })}
  </svg>
);

const WhoWeHire = () => {
  const profiles = [
    {
      role: "AI Engineers",
      icon: ICONS.brain,
      accent: <AIEngAccent />,
      skills: ["ML / Deep Learning", "NLP & Computer Vision", "Model Optimization", "Agent Frameworks"],
      color: "violet",
      iconColor: "text-violet-400",
      borderColor: "border-violet-800/30",
      hoverBorder: "hover:border-violet-600/50",
      bg: "rgba(139,92,246,0.05)",
      glow: "rgba(139,92,246,0.07)",
    },
    {
      role: "Full-Stack Engineers",
      icon: ICONS.code,
      accent: <DevAccent />,
      skills: ["React & Node.js", "Python & FastAPI", "System Design", "APIs & Integration"],
      color: "cyan",
      iconColor: "text-cyan-400",
      borderColor: "border-cyan-800/30",
      hoverBorder: "hover:border-cyan-600/50",
      bg: "rgba(6,182,212,0.05)",
      glow: "rgba(6,182,212,0.07)",
    },
    {
      role: "Product Designers",
      icon: ICONS.pen,
      accent: <DesignAccent />,
      skills: ["UI / UX Design", "Design Systems", "User Research", "Prototyping"],
      color: "amber",
      iconColor: "text-amber-400",
      borderColor: "border-amber-800/30",
      hoverBorder: "hover:border-amber-600/50",
      bg: "rgba(251,191,36,0.05)",
      glow: "rgba(251,191,36,0.07)",
    },
    {
      role: "Data Scientists",
      icon: ICONS.data,
      accent: <DataAccent />,
      skills: ["Statistical Modeling", "Experimentation", "Analytics & Insights", "Data Engineering"],
      color: "emerald",
      iconColor: "text-emerald-400",
      borderColor: "border-emerald-800/30",
      hoverBorder: "hover:border-emerald-600/50",
      bg: "rgba(52,211,153,0.05)",
      glow: "rgba(52,211,153,0.07)",
    },
  ];

  return (
    <section className="mb-20 career-fade career-fade-3">
      <div className="text-center mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
          Open Profiles
        </p>
        <h2 className="text-2xl font-semibold text-slate-100 tracking-tight mb-3">
          Who We're Looking For
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm leading-relaxed">
          Generalists who go deep. Builders who ship. Thinkers who challenge assumptions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
        {profiles.map((p, i) => (
          <div key={i}
            className={`career-bento rounded-2xl border ${p.borderColor} ${p.hoverBorder} p-6 overflow-hidden relative`}
            style={{ background: p.bg }}>
            <div className="absolute inset-0 pointer-events-none"
              style={{ background: `radial-gradient(ellipse at 80% 20%, ${p.glow} 0%, transparent 60%)` }} />

            {/* Header */}
            <div className="flex items-center justify-between mb-5">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center"
                  style={{ background: p.bg, border: `1px solid ${p.glow}` }}>
                  <Icon d={p.icon} size={20} className={p.iconColor} />
                </div>
                <h3 className={`font-bold text-base tracking-tight ${p.iconColor}`}>{p.role}</h3>
              </div>
              <div className="perk-icon-float">{p.accent}</div>
            </div>

            {/* Skills as tags */}
            <div className="flex flex-wrap gap-2">
              {p.skills.map((skill, j) => (
                <span key={j}
                  className="text-xs px-3 py-1 rounded-full text-slate-300"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// CAREER PAGE — logic completely untouched
// ─────────────────────────────────────────────────────────────────────────────
const CareerPage = ({ setCurrentPage = () => {} }) => {
  const [toast, setToast]         = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);
  

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 5000);
  };

  const handleSubmit = async (data) => {
    setSubmitting(true);
    if (!data.accessKey || data.accessKey.trim() !== ACCESS_KEY) {
      showToast("error", "❌ Your access key doesn't match.");
      setSubmitting(false);
      return;
    }
    try {
      let resumeUrl = null;
      if (data.resume instanceof File) {
        showToast("success", "📎 Uploading resume...");
        resumeUrl = await uploadResume(data.resume);
      }
      const payload = buildPayload(data, resumeUrl);
      if (!payload.referral_code) {
        showToast("error", "❌ Referral code is required.");
        setSubmitting(false);
        return;
      }
      const response = await fetch(`${API_URL}/api/v1/career/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!response.ok) {
        if (result?.error?.code === "INVALID_REFERRAL") {
          showToast("error", "❌ Invalid referral code. Please check and try again.");
        } else if (result?.error?.code === "DATABASE_ERROR") {
          showToast("error", "⚠️ Service temporarily unavailable. Please try again shortly.");
        } else if (result?.error?.code === "VALIDATION_ERROR") {
          const first = result?.error?.fields?.[0];
          showToast("error", `⚠️ ${first?.message || "Validation failed. Check your inputs."}`);
        } else {
          showToast("error", result?.error?.message || "Submission failed. Please try again.");
        }
        return;
      }
      showToast("success", `✅ Application submitted! Ref: ${result.data.application_id.slice(-8).toUpperCase()}. We'll be in touch.`);
    } catch (err) {
      console.error("Submission error:", err);
      showToast("error", err.message || "Network error. Please check your connection and try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="space-y-20 max-w-6xl mx-auto px-4 pb-20">
        <Toast toast={toast} />

        {/* ── HERO ─────────────────────────────────── */}
        <section className="relative pt-16 pb-10 text-center career-fade career-fade-1">
          <div className="career-dot-grid absolute inset-0 rounded-2xl -z-10 opacity-60" />

          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-600/30
            bg-amber-900/10 mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            <span className="text-amber-400 text-xs font-semibold tracking-widest uppercase">
              NOW RECRUITING
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-5">
            <span className="career-title-gradient">Engineer Intelligence With Us</span>
          </h1>

          <p className="text-slate-400 max-w-xl mx-auto text-base leading-relaxed mb-6">
            We're building AI that reasons from first principles, adapts under pressure,
            and turns complexity into structured clarity.
            <br />If that's the problem you want to work on — we want to talk.
          </p>
        </section>

        <div className="career-divider mb-20" />

        {/* ── THINKING STACK ───────────────────────── */}
        <ThinkingStack />

        <div className="career-divider mb-20" />

        {/* ── VALUES ───────────────────────────────── */}
        <CompanyValues />

        <div className="career-divider mb-20" />

        {/* ── PERKS ────────────────────────────────── */}
        <Perks />

        <div className="career-divider mb-20" />

        {/* ── APPLICATION FORM ─────────────────────── */}
        <section className="career-fade career-fade-4">
          <div className="text-center mb-10">
            <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
              Join Our Team
            </p>
            <h2 className="text-2xl font-semibold text-slate-100 mb-3 tracking-tight">
              Submit Your Application
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto text-sm leading-relaxed">
              Fill out the form below to apply. Make sure you have a valid referral code.
            </p>
          </div>

          <div className="career-form-container max-w-3xl mx-auto bg-slate-900/60 border border-violet-800/30
            rounded-2xl p-10 shadow-2xl backdrop-blur-xl relative">
            <div className="career-mesh-bg absolute inset-0 rounded-2xl pointer-events-none" />
            <div className="career-grid-lines absolute inset-0 rounded-2xl pointer-events-none opacity-30" />
            <div className="relative z-10">
              <DynamicForm
                fields={careerFormFields}
                onSubmit={handleSubmit}
                submitLabel={isSubmitting ? "Submitting..." : "Submit Application"}
              />
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-slate-500 text-sm">
              Don't have a referral code?{" "}
              <a href="https://wa.me/919235327048" target="_blank" rel="noopener noreferrer"
                className="text-violet-400 hover:text-violet-300 underline underline-offset-2 transition-colors">
                Request one here
              </a>
            </p>
          </div>
        </section>

        <br /><br /><br />
        <div className="career-divider mb-20" />

        {/* ── WHO WE HIRE ──────────────────────────── */}
        <WhoWeHire />

        <div className="career-divider mb-20" />

        {/* ── CLOSING CTA ──────────────────────────── */}
        <PageCTA page="Career" setCurrentPage={setCurrentPage} />

      </div>
    </>
  );
};

export default CareerPage;